export default class CustomerImageController {
	constructor() {
		this.initialized = false;
		this.handleHashChange = this.openTabFromHash.bind(this);
	}

	init() {
		if (this.initialized) {
			return;
		}

		this.initialized = true;
		this.initializeModals();
		this.initInfiniteScrolls();
		this.bindServiceUrlSync();
		this.initImageModal();
		this.zoomOnMouseMove();
		this.openTabFromHash();
		window.addEventListener('hashchange', this.handleHashChange);
	}


	initInfiniteScrolls() {
		const itemsPerPage = 10;


		document.querySelectorAll('[id^="image-gallery-"]').forEach((gallery) => {
			const categoryId = gallery.id.replace('image-gallery-', '');
			const images = Array.from(gallery.querySelectorAll('.image-item'));
			const sentinel = document.querySelector(
				`.infinite-scroll-sentinel[data-category-id="${categoryId}"]`
			);

			if (!sentinel || !images.length) {
				return;
			}

			let visibleCount = Math.min(itemsPerPage, images.length);
			images.forEach((image, index) => {
				image.hidden = index >= visibleCount;
			});

			if (visibleCount >= images.length) {
				sentinel.hidden = true;
				return;
			}

			if (!('IntersectionObserver' in window)) {
				images.forEach((image) => {
					image.hidden = false;
				});
				sentinel.hidden = true;
				return;
			}

			const observer = new IntersectionObserver(
				(entries) => {
					if (!entries.some((entry) => entry.isIntersecting)) {
						return;
					}

					visibleCount = Math.min(visibleCount + itemsPerPage, images.length);
					images.forEach((image, index) => {
						image.hidden = index >= visibleCount;
					});

					if (visibleCount >= images.length) {
						sentinel.hidden = true;
						observer.disconnect();
					}
				},
				{ rootMargin: '0px 0px 300px 0px' }
			);

			observer.observe(sentinel);
		});
	}

	initializeModals() {
		const modalTemplate = document.getElementById('modal-template');

		if (!modalTemplate) {
			return;
		}

		document.querySelectorAll('.modal-trigger').forEach((trigger) => {
			trigger.addEventListener('click', (event) => {
				event.preventDefault();
				const modalClone = modalTemplate.cloneNode(true);
				const image = modalClone.querySelector('img');
				const modalText = modalClone.querySelector('.modal-text');
				const selectElement = modalClone.querySelector('select[name="service"]');
				const modalOption = trigger.getAttribute('data-option');

				modalClone.classList.add('modal-visible');
				modalClone.style.display = 'block';

				if (image) {
					image.src = trigger.getAttribute('data-image') || '';
				}

				if (modalText) {
					modalText.textContent = trigger.getAttribute('data-modal') || '';
				}

				if (selectElement && modalOption) {
					const optionElement = document.createElement('option');
					optionElement.value = modalOption;
					optionElement.textContent = modalOption;
					selectElement.appendChild(optionElement);
				}

				const closeButton = modalClone.querySelector('.close');
				if (closeButton) {
					closeButton.addEventListener('click', () => modalClone.remove());
				}

				modalClone.addEventListener('click', (cloneEvent) => {
					if (cloneEvent.target === modalClone) {
						modalClone.remove();
					}
				});

				document.body.appendChild(modalClone);
			});
		});
	}

	openService(event, serviceButtons) {
		const trigger = event?.currentTarget || null;
		const service = trigger?.getAttribute('data-service') || '';

		if (!trigger || !service) {
			return;
		}

		const serviceButtonsArr = Array.from(serviceButtons);

		const controlledButton = serviceButtonsArr.find(
			(button) => button.getAttribute('data-service') === service && button.hasAttribute('aria-controls')
		);
		const categoryId =
			trigger.getAttribute('aria-controls') || controlledButton?.getAttribute('aria-controls') || '';

		if (!categoryId) {
			return;
		}

		document.querySelectorAll('.user_image_service a').forEach((banner) => {
			banner.style.display = 'none';
		});

		const bannerLink = document.getElementById(`bannerLink_${categoryId}`);
		const defaultBanner = document.getElementById('bannerLink_default');

		if (bannerLink) {
			bannerLink.style.display = 'block';
		} else if (defaultBanner) {
			defaultBanner.style.display = 'block';
		}

		document.querySelectorAll('.tab_content_user_image').forEach((tabContent) => {
			tabContent.style.display = 'none';
		});

		serviceButtonsArr.forEach((tabLink) => {
			tabLink.classList.remove('active_image_user');
			tabLink.setAttribute('aria-selected', String(tabLink.getAttribute('data-service') === service));

			if (tabLink.getAttribute('data-service') === service) {
				tabLink.classList.add('active_image_user');
			}
		});

		const activeTab = document.getElementById(categoryId);
		if (activeTab) {
			activeTab.style.display = 'block';
		}

		const currentUrl = new URL(window.location.href);
		currentUrl.searchParams.set('service', service);
		window.history.replaceState({}, '', currentUrl.toString());
		this.scrollCenterWhenSelected(categoryId);
	}

	openTabFromHash() {
		const hash = window.location.hash.substring(1);

		if (hash) {
			const hashButton = this.findTabButton(hash);
			if (hashButton) {
				hashButton.click();
				return;
			}
		}

		const defaultTab = document.getElementById('defaultOpen');
		if (defaultTab) {
			defaultTab.click();
		}
	}

	findTabButton(hash) {
		const directButton = Array.from(document.querySelectorAll('.tablinks')).find(
			(button) => button.getAttribute('aria-controls') === hash || button.getAttribute('data-service') === hash
		);
		if (directButton) {
			return directButton;
		}

		return Array.from(document.querySelectorAll('.tablinks')).find((button) => {
			const inlineAction = button.getAttribute('onclick') || '';
			return inlineAction.includes(`'${hash}'`);
		});
	}

	bindServiceUrlSync() {
		const serviceButtons =document.querySelectorAll('.tab_user_image .tablinks[data-service]');
		serviceButtons.forEach((button) => {
			button.addEventListener('click', (event) => this.openService(event, serviceButtons));
		});
	}
	scrollCenterWhenSelected(selectedId = '') {
		const menu = document.querySelector('.tab_user_image_mb_block');

		if (!menu) {
			return;
		}

		let activeItem = menu.querySelector('.tab_user_image_mb_item.active_image_user');

		if (selectedId) {
			activeItem = Array.from(menu.querySelectorAll('.tab_user_image_mb_item')).find(
				(button) => button.getAttribute('aria-controls') === String(selectedId)
			);
		}

		if (!activeItem) {
			return;
		}
		const centerActiveItem = function () {
			activeItem.scrollIntoView({
				behavior: 'auto',
				block: 'nearest',
				inline: 'center',
			});
		};

		requestAnimationFrame(centerActiveItem);
		if (document.readyState !== 'complete') {
			window.addEventListener('load', centerActiveItem, { once: true });
		}
	}

	initImageModal({
		modalId = 'popupCustomerImage',
		imageSelector = '.card-img-top',
		imageTargetId = 'popupZoomImage',
		closeBtnClass = '.popup-close-customer',
	} = {}) {
		const modal = document.getElementById(modalId);
		const modalImage = document.getElementById(imageTargetId);
		const closeButton = modal?.querySelector(closeBtnClass);

		if (!modal || !modalImage || !closeButton) {
			return;
		}

		document.querySelectorAll(imageSelector).forEach((image) => {
			image.addEventListener('click', () => {
				modal.style.display = 'block';
				modalImage.src = image.src;
				modalImage.alt = image.alt || '';
			});
		});

		closeButton.addEventListener('click', () => {
			modal.style.display = 'none';
		});

		modal.addEventListener('click', (event) => {
			if (event.target === modal) {
				modal.style.display = 'none';
			}
		});
	}



	zoomOnMouseMove() {
		const modalImage = document.getElementById('popupZoomImage');
		if(!modalImage) return;
		const zoomFrame = document.querySelector('.popup-customer__zoom-frame');

		if (!zoomFrame || !modalImage) {
			return;
		}

		zoomFrame.style.touchAction = 'none';

		const resetZoom = () => {
			zoomFrame.classList.remove('is-zooming');
			modalImage.style.transformOrigin = 'center';
		};


		const updateZoomPosition = (clientX, clientY) => {
			const frameRect = zoomFrame.getBoundingClientRect();
			const x = ((clientX - frameRect.left) / frameRect.width) * 100;
			const y = ((clientY - frameRect.top) / frameRect.height) * 100;

			modalImage.style.transformOrigin = `${x}% ${y}%`;
			zoomFrame.classList.add('is-zooming');
		};

		const handleTouchZoom = (event) => {
			const touch = event.touches[0];

			if (!touch) {
				return;
			}

			event.preventDefault();
			updateZoomPosition(touch.clientX, touch.clientY);
		};

		zoomFrame.addEventListener('pointermove', function (event) {
			if ('touch' === event.pointerType) {
				return;
			}

			updateZoomPosition(event.clientX, event.clientY);
		});

		zoomFrame.addEventListener('pointerleave', resetZoom);
		zoomFrame.addEventListener('touchstart', handleTouchZoom, { passive: false });
		zoomFrame.addEventListener('touchmove', handleTouchZoom, { passive: false });
		zoomFrame.addEventListener('touchend', resetZoom);
		zoomFrame.addEventListener('touchcancel', resetZoom);
		document.querySelector('.close-modal_cn')?.addEventListener('click', resetZoom);
		document.getElementById('popupCustomerImage')?.addEventListener('click', function (event) {
			if (event.target === event.currentTarget) {
				resetZoom();
			}
		});
	}
}
